import { useNavigate } from "react-router-dom";
import MobileShell from "@/components/MobileShell";
import { ArrowLeft, AlertTriangle, Pause, MinusCircle, PhoneCall, AlertOctagon } from "lucide-react";

const STEPS = [
  { icon: Pause, title: "Pause and reassure", body: "Flare-ups are common in rehab. They are usually short-lived and do not mean damage.", tone: "teal" },
  { icon: MinusCircle, title: "Reduce load", body: "Drop today's volume by 30–50%. Walk gently. Avoid the aggravating position for 24–48 hours.", tone: "amber" },
  { icon: AlertTriangle, title: "Modify exercises", body: "Use the easier version listed in each exercise. Stay within a tolerable pain level (≤5/10).", tone: "amber" },
  { icon: AlertTriangle, title: "When to stop", body: "Stop if pain is sharp, radiates further, or symptoms worsen for more than 48 hours.", tone: "rose" },
  { icon: PhoneCall, title: "Contact the clinic", body: "If symptoms persist beyond 7 days or you're unsure, book a clinic review.", tone: "teal" },
  { icon: AlertOctagon, title: "Urgent care", body: "Seek urgent care for new bowel/bladder changes, saddle numbness, progressive weakness, or unrelenting night pain.", tone: "rose" },
];

const toneMap = {
  teal: "bg-teal-50 text-teal-700",
  amber: "bg-amber-50 text-amber-700",
  rose: "bg-rose-50 text-rose-700",
};

export default function FlareUp() {
  const navigate = useNavigate();
  return (
    <MobileShell>
      <header className="px-6 pt-8 pb-4">
        <button onClick={() => navigate(-1)} className="text-slate-500 mb-3" data-testid="back-btn"><ArrowLeft size={20} /></button>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-600">Flare-up guidance</p>
        <h1 className="text-2xl font-bold font-display text-slate-900 mt-1">Pain spiking? Here's what to do.</h1>
      </header>

      <ol className="px-6 space-y-3 pb-8" data-testid="flareup-steps">
        {STEPS.map((s, i) => {
          const I = s.icon;
          return (
            <li key={s.title} className="bg-white rounded-2xl border border-slate-100 p-4 flex gap-3">
              <span className={`w-10 h-10 rounded-full grid place-items-center shrink-0 ${toneMap[s.tone]}`}>
                <I size={18} />
              </span>
              <div>
                <div className="font-semibold text-slate-900">{s.title}</div>
                <div className="text-sm text-slate-600 mt-1 leading-relaxed">{s.body}</div>
              </div>
            </li>
          );
        })}
      </ol>
    </MobileShell>
  );
}
